import useSWR from 'swr';
import { consignmentService } from 'services';
import { Heading, Loading, Product, Text } from 'components';
import { swrKeys } from 'helpers';
import { FontWeight } from 'commons';
import * as S from './styles';

interface Props {
  consignmentCode: string;
  reasonOfRefusal?: string;
  reasonOfRevokeDescription?: string;
}

export function PerformanceProductList({
  consignmentCode,
  reasonOfRefusal,
  reasonOfRevokeDescription,
}: Props) {
  const { data, isValidating } = useSWR(
    swrKeys.consignmentDetails({ consignmentCode }),
    () => consignmentService.getDetails(consignmentCode),
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      revalidateOnReconnect: false,
    }
  );

  const isLoading = !data || isValidating;

  return (
    <S.Main $isLoading={isLoading}>
      {reasonOfRefusal && (
        <S.TextWrapper>
          <Heading weight={FontWeight.bold}>Motivo - {reasonOfRefusal}</Heading>

          <Text>
            {reasonOfRevokeDescription
              ? reasonOfRevokeDescription
              : 'Sem informações adicionais'}
          </Text>
        </S.TextWrapper>
      )}

      <Heading weight={FontWeight.bold}>Produtos</Heading>
      {isLoading ? (
        <Loading />
      ) : (
        data.entries.map((entry) => {
          return <Product key={entry.product.code} entry={entry} />;
        })
      )}
    </S.Main>
  );
}
